import { SchemaConvertor } from './schema.convertor';
import { TransformConvertorBase } from './transform.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { InputTransformation } from 'app/model/dataflow/inputtransformation';
import { InputPlainObject } from 'worker/app-workers/shared/plainObjects/input.plainObject';
import { DataFlowExpressionUtils } from '../../expression.util';
import { BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';
import { IResourceContext } from 'shell-models-lib';

export class InputConvertor extends TransformConvertorBase {
    private get inputTransform(): InputTransformation {
        return this.transformation as InputTransformation;
    }

    private get inputObject(): InputPlainObject {
        return this.transformObject as InputPlainObject;
    }

    constructor(inputObject: InputPlainObject, input: InputTransformation) {
        super(inputObject, input);
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        this.inputTransform.schema = SchemaConvertor.convertColumnsFromPlainObject(
            this.inputObject.columns,
            this.inputTransform
        );

        if (this.inputObject.configs.has('order')) {
            const order = this.inputObject.configs.get('order');
            this.inputTransform.order = parseInt(order, 10);
            this._handledConfigs.push('order');
        }

        if (this.inputObject.configs.has('allowSchemaDrift')) {
            this.inputTransform.allowSchemaDrift = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                this.inputObject.configs.get('allowSchemaDrift'),
                this.inputTransform,
                BooleanDataFlowType.TYPE
            );
            this._handledConfigs.push('allowSchemaDrift');
        }

        super.postConvert();
        return this.inputTransform;
    }
}
